import React, { useState, useRef, useEffect } from "react";
import { Navbar, Nav, Container, Offcanvas, Image } from "react-bootstrap";
import { FaHeart, FaUser, FaGear, FaRightToBracket } from "react-icons/fa6";
import { Link, useLocation, useNavigate } from "react-router-dom";
import NotificationComponent from "./NotificationComponent";
import { useAuth } from "../../provider/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { useScreenSize } from "provider/ScreenSizeProvider";

const Header = () => {
  const location = useLocation();
  const referrer = location.pathname + location.search;
  const navigate = useNavigate();
  const { logout, userProfile } = useAuth();
  const profileMenuRef = useRef(null);
  const dropdownRef = useRef(null);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  // const [activeLink, setActiveLink] = useState("/");

  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const { isMobileView } = useScreenSize();
  const currentPath = location.pathname;
  const handleMenuClose = () => {
    setShowProfileDropdown(false);
  };

  // Check login state on mount
  useEffect(() => {
    if (userProfile) {
      setIsLoggedIn(true);
    }

    const handleClickOutside = (event) => {
      // Check if click is outside profileMenuRef
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target)
      ) {
        setIsProfileMenuOpen(false);
      }

      // Check if click is outside dropdownRef
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowProfileDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [userProfile]);

  const toggleProfileMenu = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };
  const handleLogout = () => {
    logout();
    setIsLoggedIn(false);
    setIsProfileMenuOpen(false);
    navigate(referrer, { replace: true });
    window.location.reload();
  };

  //Active path
  const isSharedSafariActive =
    location.pathname.startsWith("/sharesafari") ||
    location.pathname.startsWith("/sharedsafari");

  const isSafariPackageActive =
    location.pathname.startsWith("/package") ||
    location.pathname.startsWith("/package");

  const isParkActive =
    location.pathname === "/" || location.pathname.startsWith("/park");

  return (
    <>
      <header className="header_wrapper">
        <Navbar expand="lg">
          <Container fluid>
            <Link to="/">
              <Image
                src={"/img/WLogoLightgreen.svg"}
                alt="logo"
                width="40px"
                className="logo pt-1"
              />
            </Link>
            {!isMobileView && (
              <div className="d-flex align-items-center d-lg-block d-none">
                <Navbar.Toggle aria-controls="offcanvasNavbar" />
                <Navbar.Offcanvas
                  id="offcanvasNavbar"
                  placement="end"
                  className="header_canvas"
                >
                  <Offcanvas.Header closeButton className="ps-1">
                    <Offcanvas.Title>
                      <a href="/park">
                        <Image
                          src={"/img/WLogoLightgreen.svg"}
                          alt=""
                          className="logo ps-2"
                        />
                      </a>
                    </Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body className=" pt-2  position-relative">
                    <Nav className="me-auto menu-navbar-nav navbar-nav">
                      <Nav.Item
                        className={`nav-item text-lg-center ${isParkActive ? "active" : ""
                          }`}
                      >
                        <Link to="/" className="nav-link">
                          <div className="card-img">
                            <Image
                              src={"/img/plansafari-icon.png"}
                              alt=""
                              width="32"
                              type="image/png"
                              loading="lazy"
                            />
                          </div>
                          Plan Safari
                        </Link>
                      </Nav.Item>
                      <Nav.Item
                        className={`nav-item text-lg-center ${isSafariPackageActive ? "active" : ""
                          }`}
                      >
                        <Link to="/package" className="nav-link">
                          <div className="card-img">
                            <Image
                              src={"/img/packageicon.png"}
                              alt=""
                              width="22"
                              type="image/png"
                              loading="lazy"
                            />
                          </div>
                          Safari Packages
                        </Link>
                      </Nav.Item>
                      <Nav.Item
                        className={`nav-item text-lg-center ${isSharedSafariActive ? "active" : ""
                          }`}
                      >
                        <Link to="/sharesafari" className="nav-link">
                          <div className="card-img">
                            <Image
                              src={"/img/safaric.png"}
                              alt=""
                              width="32"
                              type="image/png"
                              loading="lazy"
                            />
                          </div>
                          Shared Safari
                        </Link>
                      </Nav.Item>
                    </Nav>
                  </Offcanvas.Body>
                </Navbar.Offcanvas>
              </div>
            )}
            <div className="d-flex gap-4 align-items-center justify-content-end initial_headers">
              {/* {isLoggedIn && (
                <>
                  <NotificationComponent />
                  <Link to="/chat" className="d-none d-lg-block">
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      color="#ffffff"
                      size="xl"
                    />
                  </Link>
                </>
              )} */}

              <div
                className="profilewrapper d-lg-block d-none"
                ref={profileMenuRef}
              >
                <div
                  className="profile"
                  onClick={toggleProfileMenu}
                  style={{ cursor: "pointer" }}
                >
                  <div className="img-box2">
                    <Image
                      src={
                        userProfile?.profile_display_image || "/img/user.png"
                      }
                      alt=""
                      className="me-1 d-xl-inline-flex rounded-circle"
                      width="30"
                      height="30"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/img/user.png"; 
                      }}
                    />
                  </div>
                </div>

                <div
                  className={`menuprofile ${isProfileMenuOpen ? "active" : ""}`}
                >
                  <div className="profileBoxwrap">
                    {isLoggedIn && userProfile ? (
                      <>
                        <div className="profile_details d-flex gap-2">
                          <div className="img-box2">
                            <Image
                              src={
                                userProfile?.profile_display_image ||
                                "/img/user.png"
                              }
                              alt="logo"
                              className="bg-info me-1 d-xl-inline-flex rounded-circle"
                              width={35}
                              height={35}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "/img/user.png"; 
                              }}
                            />
                          </div>
                          <div className="profile_name">
                            <h6>{userProfile?.name || "User"}</h6>
                            <p>@{userProfile?.user_handle || "@username"}</p>
                          </div>
                        </div>
                        <ul>
                          <li>
                            {userProfile?.is_safari_operator ?
                              <Link
                                to={`/operator/${userProfile?.operator_slug}/profile`}
                                onClick={() => setIsProfileMenuOpen(false)}
                              >
                                <FaUser /> Profile
                              </Link>
                              :
                              <Link
                                to={`/profile/user/${userProfile?.user_handle}`}
                                onClick={() => setIsProfileMenuOpen(false)}
                              >
                                <FaUser /> Profile
                              </Link>
                            }
                          </li>
                           {/* {userProfile?.is_safari_operator &&
                            <>
                              <li>
                                <Link
                                  to="/manage"
                                  onClick={() => setIsProfileMenuOpen(false)}
                                >
                                  <FaGear /> Account Setting
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/account/wishlist"
                                  onClick={() => setIsProfileMenuOpen(false)}
                                >
                                  <FaHeart /> Wishlist
                                </Link>
                              </li>
                            </>
                          } */}
                          {!userProfile?.is_safari_operator &&
                            <>
                              <li>
                                <Link
                                  to="/account"
                                  onClick={() => setIsProfileMenuOpen(false)}
                                >
                                  <FaGear /> Account Setting
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/account/wishlist"
                                  onClick={() => setIsProfileMenuOpen(false)}
                                >
                                  <FaHeart /> Wishlist
                                </Link>
                              </li>
                            </>
                          }

                          <li className="border-top">
                            <Link
                              data-method="POST"
                              className="py-3"
                              onClick={(e) => {
                                e.preventDefault();
                                handleLogout();
                              }}
                            >
                              <i className="fa-solid fa-arrow-right-from-bracket"></i>{" "}
                              Log Out
                            </Link>
                          </li>
                        </ul>
                      </>
                    ) : (
                      <ul>
                        <li>
                          <Link
                            to={`/log-in?authclient=google&referrer=${encodeURIComponent(referrer)}`}
                            className="border-top"
                            onClick={() => setIsProfileMenuOpen(false)}
                          >
                            <FaRightToBracket /> Log in
                          </Link>
                        </li>
                      </ul>
                    )}
                  </div>
                </div>
              </div>

              <Navbar.Toggle aria-controls="offcanvasNavbar" className="d-none">
                <i className="fa-solid fa-bars"></i>
              </Navbar.Toggle>
            </div>
          </Container>
        </Navbar>
      </header>
      {isMobileView && (
        <div className="Mobile_navbar">
          <div className="container-fluid">
            <div className="d-flex justify-content-between">
              <div
                className={`links-mobile text-center ${currentPath === "/" ? "active" : ""
                  }`}
              >
                <Link className="nav-link" to="/">
                  <div className="d">
                    <div className="card-img2 text-center">
                      <img src={"/img/plansafari-icon.png"} alt="" width="32" />
                    </div>{" "}
                    <span>Plan Safari</span>
                  </div>
                </Link>
              </div>
              <div
                className={`links-mobile text-center ${currentPath === "/package" ? "active" : ""
                  }`}
              >
                <Link to="/package" className="nav-link">
                  <div className="card-img22 text-center">
                    <img src={"/img/packageicon.png"} alt="" width="20" />
                  </div>
                  <span>Packages</span>
                </Link>
              </div>
              <div
                className={`links-mobile text-center ${currentPath === "/sharesafari" ? "active" : ""
                  }`}
              >
                <Link to="/sharesafari" className="nav-link">
                  <div className="card-img2 text-center">
                    <img src={"/img/safaric.png"} alt="" width="32" />
                  </div>
                  <span>Shared Safari</span>
                </Link>
              </div>
              {isLoggedIn && (
                <div
                  className={`links-mobile text-center ${currentPath === "/chat" ? "active" : ""
                    }`}
                >
                  <Link to="/chat" className="nav-link">
                    <div className="card-img2 text-center">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="envelope"
                        className="svg-inline--fa fa-envelope fa-xl "
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        color="#ffffff"
                      >
                        <path
                          fill="currentColor"
                          d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"
                        ></path>
                      </svg>
                    </div>
                    <span>Message</span>
                  </Link>
                </div>
              )}

              <div className="links-mobile">
                {isLoggedIn ? (
                  <div className="proilewrapper position-relative" >
                    <div
                      className="profile2 justify-content-center"
                      onClick={() =>
                        setShowProfileDropdown(!showProfileDropdown)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <div className="img-box2 mobileee d-flex flex-column align-items-center">
                        <Link>
                          <img
                            src={
                              userProfile?.profile_display_image ||
                              "/img/user.png"
                            }
                            alt=""
                            className="rounded-circle"
                            width="25"
                            height="25"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/img/user.png"; 
                            }}
                          />
                          <span>You</span>
                        </Link>
                      </div>
                    </div>

                    {/* Dropdown box only shown when showProfileDropdown is true */}
                    {showProfileDropdown && (
                      <div className="menuprofile2 position-absolute" ref={dropdownRef}>
                        <div className="profileBoxwrap">
                          <div className="profile_details d-flex gap-2">
                            <div className="img-box2  ">
                              <img
                                src={
                                  userProfile?.profile_display_image ||
                                  "/img/user.png"
                                }
                                alt=""
                                className="me-1 d-xl-inline-flex rounded-circle"
                                width="35"
                                height="35"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = "/img/user.png"; 
                                }}
                              />
                            </div>
                            <div className="profile_name">
                              <h6>{userProfile?.name || "User"}</h6>
                              <p>@{userProfile?.user_handle || "@username"}</p>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <Link to={`/profile/user/${userProfile?.user_handle}`} onClick={handleMenuClose}>
                                <i className="fa-solid fa-user"></i> Profile
                              </Link>

                            </li>
                            <li>
                              <Link to="/account" onClick={handleMenuClose}>
                                <i className="fa-solid fa-cog"></i> Account
                                Setting
                              </Link>
                            </li>
                            <li>
                              <Link to="/account/wishlist" onClick={handleMenuClose}>
                                <i className="fa-solid fa-heart"></i> Wishlist
                              </Link>

                            </li>
                            <li className="border-top">
                              <Link
                                data-method="POST"
                                className="py-3"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleLogout();
                                  handleMenuClose();
                                }}
                              >
                                <i className="fa-solid fa-arrow-right-from-bracket"></i>{" "}
                                Log Out
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div
                    className={`links-mobile ${currentPath === "/log-in" ? "active" : ""
                      }`}
                  >
                    <Link to="/log-in" className="nav-link">
                      <div className="img-box2 mobileee text-center">
                        <img
                          src="/img/user.png"
                          alt=""
                          className="rounded-circle"
                          width="25"
                          height="25"
                        />
                      </div>
                      <span>Login</span>
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
